/**
 * Simple accordion toggle for `.accordion` blocks used in product descriptions
 * and page content. Moved out of an inline <script> in layout/theme.liquid so
 * the code is cacheable across pages and CSP-friendly. Behavior is unchanged:
 * clicking a header closes any open item in the same accordion and toggles the
 * clicked one.
 */
(function () {
  function initAccordions() {
    document.querySelectorAll('.accordion__header').forEach(function (header) {
      if (header.dataset.accordionBound) return;
      header.dataset.accordionBound = 'true';
      header.addEventListener('click', function (e) {
        e.preventDefault();
        var isActive = this.classList.contains('is-active');
        var accordion = this.closest('.accordion');
        if (!accordion) return;
        accordion.querySelectorAll('.is-active').forEach(function (el) {
          el.classList.remove('is-active');
        });
        if (!isActive) {
          this.classList.add('is-active');
          var body = this.nextElementSibling;
          if (body && body.classList.contains('accordion__body')) {
            body.classList.add('is-active');
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }

  // Re-bind after the theme editor re-renders a section.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAccordions);
  }
})();
